<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
    <g>
      <path fill="none" d="M60.631,46.5H46.537c1.547,18,10.466,27.595,20.247,35.816c-0.292-0.879-0.58-1.647-0.85-2.541
        C62.521,68.51,61.163,57.5,60.631,46.5z"/>
      <path fill="none" d="M87.738,99.522c1.065,1.163,2.041,2.324,2.9,3.581l-0.023-0.005c4.021,4.737,8.864,9.11,14.708,13.028
        c5.844-3.918,10.688-8.306,14.708-13.045l-0.022-0.02c0.849-1.238,1.814-2.34,2.866-3.492
        c13.76-18.658,16.167-42.071,16.457-64.071H71.315C71.605,57.5,74.011,80.87,87.738,99.522z"/>
      <path fill="none" d="M84.508,154.5h41.632c-2.12-5-6.961-9-12.579-9H97.088C91.471,145.5,86.63,149.5,84.508,154.5z"/>
      <path fill="none" d="M144.715,79.66c-0.297,0.98-0.611,2.064-0.935,3.025c10.045-8.27,19.286-18.186,20.875-36.186h-14.638
        C149.486,57.5,148.128,68.395,144.715,79.66z"/>
      <path class="color" fill="#F45B5B" d="M154.373,35.5c-1.175,1-2.873,1.913-4.77,1.913c-3.546,0-6.421-2.911-6.421-6.457s2.875-6.457,6.421-6.457
        H60.885c3.545,0,6.42,2.801,6.42,6.346c0,3.546-2.875,6.605-6.42,6.605c-1.896,0-3.595-0.951-4.77-1.951H34.5v5.049
        c0,14.051,4.103,25.923,11.702,36.296c6.45,8.806,14.769,14.985,21.926,20.438c4.456,3.393,8.361,6.423,11.17,9.485
        c5.512,7.296,12.202,13.635,20.202,18.881v9.851h-2.412c-13.624,0-25.588,10.295-25.588,23.921v5.079h66v-5.079
        c0-13.626-10.316-23.921-23.939-23.921H110.5v-9.851c8-5.237,14.889-11.562,20.395-18.842c2.838-3.085,6.967-6.141,11.514-9.565
        c7.234-5.447,15.285-11.621,21.811-20.417c7.693-10.372,11.281-22.238,11.281-36.277V35.5H154.373z M46.537,46.5h14.095
        c0.531,11,1.89,21.895,5.302,33.16c0.27,0.894,0.558,1.892,0.85,2.771C57.003,74.21,48.083,64.5,46.537,46.5z M113.561,145.5
        c5.618,0,10.459,4,12.579,9H84.508c2.123-5,6.963-9,12.58-9H113.561z M122.875,99.57c-1.052,1.149-2.018,2.295-2.866,3.533
        l0.022-0.005c-4.02,4.737-8.864,9.11-14.708,13.028c-5.843-3.918-10.687-8.306-14.708-13.045l0.023-0.02
        c-0.86-1.257-1.835-2.375-2.9-3.54C74.011,80.871,71.605,57.5,71.315,35.5h68.017C139.042,57.5,136.635,80.911,122.875,99.57z
        M143.78,82.57c0.323-0.961,0.638-1.814,0.935-2.795c3.413-11.266,4.771-22.275,5.303-33.275h14.638
        C163.066,64.5,153.825,74.301,143.78,82.57z"/>
      <path class="color" fill="#F45B5B" d="M60.301,24.352v0.03c0.193-0.017,0.387-0.03,0.584-0.03H60.301z"/>
      <path class="color" fill="#F45B5B" d="M150.347,24.352h-0.743c0.253,0,0.499,0.018,0.743,0.047V24.352z"/>
      <path class="color" fill="#F45B5B" d="M61.606,38.636c3.943,0,7.142-3.198,7.142-7.142c0-3.944-3.198-7.142-7.142-7.142
        c-0.22,0-0.436,0.014-0.65,0.033c-3.639,0.328-6.492,3.384-6.492,7.109c0,1.834,0.699,3.502,1.836,4.768
        C57.607,37.715,59.497,38.636,61.606,38.636z"/>
      <path class="color" fill="#F45B5B" d="M141.933,31.397c0,3.891,3.155,7.045,7.046,7.045c2.081,0,3.944-0.908,5.233-2.341
        c1.124-1.249,1.812-2.894,1.812-4.704c0-3.614-2.724-6.59-6.229-6.994c-0.268-0.031-0.538-0.051-0.815-0.051
        C145.088,24.352,141.933,27.507,141.933,31.397z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TrophyIcon'
}
</script>
